import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Space, notification } from 'antd';
import api from '../services/api';
import EditModal from '../components/EditModal';

const UserManagement = ({ card }) => {
  const [_api, setApi] = notification.useNotification();
  const [clubs, setClubs] = useState([]);
  const [selectedClub, setSelectedClub] = useState(null);
  const [users, setUsers] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState({
    "name": "", "tag": "", "text": "", "show": false, "img": "", "club": "",level:""

  });
  const [loading, setLoading] = useState(true);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  
  // 批量操作相关状态
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [batchDeleteVisible, setBatchDeleteVisible] = useState(false);
  
  // 分页状态
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  const setNotification = (config) => {
    _api.open(config);
  }

  // 加载社团列表
  useEffect(() => {
    const loadClubs = async () => {
      try {
        setLoading(true);
        const res = await api.getClubs();
        setClubs(res.data);
      } catch (e) {
        setNotification({
          type: 'error',
          message: '加载社团列表失败',
          description: e.message,
        });
      } finally {
        setLoading(false);
      }
    };
    
    loadClubs();
  }, [card]);

  // 加载社团成员
  const loadClubMembers = async (club) => {
    try {
      setLoading(true);
      const res = await api.getJson(club);
      const filteredUsers = res.data.filter(user => user.name !== '尽情期待');
      setUsers(filteredUsers);
      setPagination(prev => ({
        ...prev,
        total: filteredUsers.length
      }));
    } catch (e) {
      setUsers([]);
      setPagination(prev => ({
        ...prev,
        total: 0
      }));
    } finally {
      setLoading(false);
    }
  };

  // 编辑用户
  const handleEditUser = (user) => {
    user.isset = true;
    setCurrentUser({"name": "", "tag": "", "text": "", "show": false, "img": "", "club": "",level:""})
    setCurrentUser(user);
    setEditModalVisible(true);
  };

  // 删除用户
  const handleDeleteUser = (user) => {
    setCurrentUser(user);
    setDeleteModalVisible(true);
  };

  const DeleteUser = async () => {
    try {
      setLoading(true);
      await api.deleteJson(selectedClub, currentUser.name);
      setDeleteModalVisible(false);
      setNotification({
        type: 'success',
        message: '删除成功',
        description: '用户已成功删除',
      });
      loadClubMembers(selectedClub);
    } catch (e) {
      setNotification({
        "type": "error",
        "message": "删除失败",
        description: e.message
      });
      setDeleteModalVisible(false);
    } finally {
      setLoading(false);
    }
  };

  // 批量删除处理函数
  const handleBatchDelete = async () => {
    try {
      setLoading(true);
      let success_count = 0;
      const total_count = selectedUsers.length;
      
      // 准备所有删除请求
      const deletePromises = selectedUsers.map(async (userName) => {
        try {
          await api.deleteJson(selectedClub, userName);
          success_count++;
        } catch (error) {
          console.error(`删除失败 ${userName}:`, error);
        }
      });
      
      // 执行所有删除
      await Promise.all(deletePromises);
      
      // 显示结果通知
      setNotification({
        type: "info",
        message: "批量删除完成",
        description: `共 ${total_count} 个，成功: ${success_count} 个，失败: ${total_count - success_count} 个`
      });
      
      // 重置选择状态并刷新数据
      setSelectedUsers([]);
      setIsSelecting(false);
      setBatchDeleteVisible(false);
      loadClubMembers(selectedClub);
    } catch (error) {
      setNotification({
        type: "error",
        message: "批量删除失败",
        description: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAddUser = async () => {
    setCurrentUser({
      "name": "",
      "tag": "",
      "isadd": true,
      "text": "",
      "show": false,
      "img": "",
      "club": selectedClub,
      "level": ""

    });
    setEditModalVisible(true);
  };

  // 保存用户信息
  const handleSaveUser = async (values) => {
    try {
      setLoading(true);
      if (!currentUser.isadd) {
        var t = values.name;
        values.new_name = t;
        values.name = currentUser.name;
        await api.changeJson({
          club: selectedClub,
          ...values
        });
      } else {
        values.img = values.img_b;
        delete values.img_b;
        await api.setJson({
          club: selectedClub,
          ...values
        });
        setNotification({
          type: 'success',
          message: '添加成功',
          description: '用户已成功添加',
        });
      }
      setEditModalVisible(false);
      loadClubMembers(selectedClub);
    } catch (e) {
      setNotification({
        type: "error",
        message: "错误",
        description: e.message
      });
      setEditModalVisible(false);
    } finally {
      setLoading(false);
    }
  };

  // 自动刷新数据
  useEffect(() => {
    if (selectedClub) {
      const interval = setInterval(() => {
        setRefreshKey(prev => prev + 1);
      }, 10000);
      
      return () => clearInterval(interval);
    }
  }, [selectedClub]);

  useEffect(() => {
    if (selectedClub) {
      loadClubMembers(selectedClub);
    }
  }, [selectedClub, refreshKey]);

  // 行选择配置
  const rowSelection = isSelecting ? {
    selectedRowKeys: selectedUsers,
    onChange: (selectedRowKeys) => {
      setSelectedUsers(selectedRowKeys);
    },
  } : null;

  const columns = [
    {
      title: '用户名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '标签',
      dataIndex: 'tag',
      key: 'tag',
    },
    {
      title: '状态',
      key: 'status',
      render: (_, record) => (
        <span style={{ color: record.show ? 'green' : 'red' }}>
          {record.show ? '已展示' : '未展示'}
        </span>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button 
            type="link" 
            disabled={!card}
            onClick={() => handleEditUser(record)}
          >
            编辑
          </Button>
          <Button 
            type="link" 
            danger 
            disabled={!card}
            onClick={() => handleDeleteUser(record)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {setApi}
      <Table
        dataSource={clubs}
        loading={loading}
        rowKey="club"
        columns={[
          {
            title: '社团ID',
            dataIndex: 'club',
            key: 'club',
          },
          {
            title: '社团名称',
            dataIndex: 'name',
            key: 'name',
          },
          {
            title: '操作',
            key: 'action',
            render: (_, record) => (
              <Button 
                disabled={!card || record.club == "Home"}
                onClick={() => {
                  setSelectedClub(record.club);
                  loadClubMembers(record.club);
                }}
              >
                查看成员
              </Button>
            ),
          },
        ]}
      />

      {/* 成员管理模态框 */}
      <Modal
        title={`${selectedClub} - 成员管理`}
        visible={!!selectedClub}
        width={800}
        onCancel={() => {
          setSelectedClub(null);
          setIsSelecting(false);
          setSelectedUsers([]);
        }}
        footer={null}
      >
        <div style={{ marginBottom: 16 }}>
          <Button 
            type="primary" 
            onClick={() => setIsSelecting(!isSelecting)}
            style={{ marginRight: 8 }}
          >
            {isSelecting ? "取消选择" : "批量操作"}
          </Button>
          
          {isSelecting && (
            <Button
              type="primary"
              danger
              onClick={() => setBatchDeleteVisible(true)}
              disabled={selectedUsers.length === 0}
            >
              批量删除
            </Button>
          )}
          
          <Button 
            type="primary" 
            onClick={handleAddUser} 
            disabled={!selectedClub}
            style={{ float: 'right' }}
          >
            添加用户
          </Button>
        </div>
        
        <Table
          dataSource={users}
          columns={columns}
          loading={loading}
          rowKey="name"
          pagination={{
            ...pagination,
            onChange: (page, pageSize) => {
              setPagination(prev => ({
                ...prev,
                current: page,
                pageSize
              }));
            },
            showSizeChanger: false,
            pageSizeOptions: ['10', '20', '50'],
            showTotal: total => `共 ${total} 条`
          }}
          rowSelection={rowSelection}
        />
      </Modal>

      {/* 单个删除确认对话框 */}
      <Modal
        title={`${currentUser.name} - 确认删除`}
        open={deleteModalVisible}
        width={400}
        okType='danger'
        okText="删除"
        cancelText="取消"
        onCancel={() => {
          setCurrentUser({
            "name": "", "tag": "", "text": "", "show": false, "img": "", "club": "",level:""
          });
          setDeleteModalVisible(false);
        }}
        onOk={DeleteUser}
      >
        <p>确认删除 {currentUser.name} 吗？</p>
      </Modal>

      {/* 批量删除确认对话框 */}
      <Modal
        title="批量删除确认"
        open={batchDeleteVisible}
        width={400}
        okType='danger'
        okText="确认删除"
        cancelText="取消"
        onCancel={() => setBatchDeleteVisible(false)}
        onOk={handleBatchDelete}
      >
        <p>确认要删除选中的 {selectedUsers.length} 个用户吗？</p>
      </Modal>

      <EditModal
        visible={editModalVisible}
        initialValues={currentUser}
        onOk={handleSaveUser}
        onCancel={() => setEditModalVisible(false)}
      />
    </div>
  );
};

export default UserManagement;
